import TableEntityBase from "./TableEntityBase";

export default class Registration extends TableEntityBase {
    Name:string|null = null;
    Email:string|null = null;
    Comment:string = '';
    AllowEmails:boolean = false;
    MobileNumber:string|null = null;
    Paid:boolean = false;
}